import React from "react";
import style from "./Obe.module.css";
import "bootstrap/dist/css/bootstrap.min.css";
import obe1 from "../../assets/obe1.1.jpg";
import obe2 from "../../assets/obe1.2.png";
import obe3 from "../../assets/obe1.3.jpg";
import obe4 from "../../assets/obe1.4.jpg";

const Obe = () => {
  return (
    <div>
      <div className={style.obe_bg_cnt}>
        <div className={style.obe_cnt}></div>
      </div>
      <div className="container">
        <h1 className={style.obe_heading}>Key Features</h1>
        {[
          {
            img: obe1,
            title: "Curriculum Alignment",
            description:
              "Align your curriculum with predefined learning outcomes. Our OBE software ensures that every element of your academic program contributes directly to the mastery of essential skills and knowledge.",
          },
          {
            img: obe2,
            title: "Learning Outcome Mapping",
            description:
              "Map learning outcomes to individual courses and assessments. Visualize the progression of student skills and knowledge throughout their academic journey, providing valuable insights for continuous improvement.",
          },
          {
            img: obe3,
            title: "Analytics and Reporting",
            description:
              "Access powerful analytics and reporting tools. Gain actionable insights into student performance, curriculum effectiveness, and areas for improvement. Make informed decisions to enhance the overall quality of education.",
          },
          {
            img: obe4,
            title: "Student-Centric Approach",
            description:
              "Foster a student-centric approach to education. Our OBE software empowers students to take charge of their learning journey, providing them with a clear understanding of the skills and knowledge they are expected to acquire.",
          },
        ].map((item, index) => (
          <div key={index} className={style.obe_card_cnt}>
            <img
              src={item.img}
              alt={item.title}
              className={style.obe_card_img}
            />
            <div className={style.obe_card}>
              <h1>{item.title}</h1>
              <p>{item.description}</p>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Obe;
